import React from "react";
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getLangFromPath, buildPathWithLang } from '../i18n/lang';
import { useAuth } from "../authContext";

export default function AuthButton({ isAuth: isAuthProp, userName: userNameProp }) {
  const { t } = useTranslation('common');
  const loc = useLocation();
  const currentLang = getLangFromPath(loc.pathname);
  const l = (p) => buildPathWithLang(currentLang, p);
  const navigate = useNavigate();
  const { isAuth: ctxIsAuth, user, logout } = useAuth();

  const isAuth = typeof isAuthProp === 'boolean' ? isAuthProp : ctxIsAuth;
  const userName = typeof userNameProp === 'string' ? userNameProp : (user?.name || user?.email || '');

  if (!isAuth) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          background: '#fff',
          border: 'none',
          borderRadius: 22,
          padding: '6px 18px',
          fontWeight: 600,
          fontSize: 18,
          color: '#111',
          cursor: 'pointer'
        }}
      >
        <Link
          to={l('/register')}
          style={{ color: '#111', textDecoration: 'none' }}
        >
          {t('auth.register').toUpperCase()}
        </Link>
        <span style={{ color: 'rgb(0,110,69)', fontSize: 14, margin: '0 10px' }}>●</span>
        <Link
          to={l('/login')}
          style={{ color: '#111', textDecoration: 'none' }}
        >
          {t('auth.login').toUpperCase()}
        </Link>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        background: '#fff',
        border: 'none',
        borderRadius: 22,
        padding: '6px 18px',
        fontWeight: 600,
        fontSize: 18,
        color: '#111'
      }}
    >
      {/* Никнейм → Кабинет */}
      <span
        style={{ cursor: 'pointer' }}
        onClick={() => navigate(l('/profile'))}
      >
        {userName}
      </span>

      <span style={{ color: 'rgb(0,110,69)', fontSize: 14, margin: '0 10px' }}>●</span>

      {/* Выход → на главную */}
      <span
        style={{ cursor: 'pointer' }}
        onClick={async () => {
          await logout();
          navigate(l('/'));
        }}
      >
        {t('auth.logout').toUpperCase()}
      </span>
    </div>
  );
}
